import styled from 'styled-components';

import {ResizeHandle} from '../types/ResizeHandle';
import {getResizeHandleStyle} from '../utils/getResizeHandleStyle';

// One of the eight resize handles on the edges of a selected box; `useLayerDrag` reads the
// handle from its `data-handle` attribute.
export const LayerResizeHandle = styled.div.attrs<{$handle: ResizeHandle}>((props) => ({
  style: getResizeHandleStyle(props.$handle),
}))<{$handle: ResizeHandle}>`
  position: absolute;
  width: ${(props) => props.theme.getSize(2)};
  height: ${(props) => props.theme.getSize(2)};
  background: ${(props) => props.theme.colors.general.white};
  border: 1px solid ${(props) => props.theme.colors.general.accent};
  border-radius: ${(props) => props.theme.radii.xSmall};
  transform: translate(-50%, -50%);
  touch-action: none;
`;
